import FashLogo from './Fash creative.png';

export { FashLogo };
